module.exports = __webpack_public_path__ + "static/media/img3-2.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/nutricheck_foliar/FE/img3-2.png
// module id = 2238
// module chunks = 3